import { wrapNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const SharePlayPage = wrapNavigatorScreen(() => null, {
  cardOverlayEnabled: true,
  animationEnabled: false,
  detachPreviousScreen: false,
  cardStyle: {
    backgroundColor: 'transparent',
  },
  headerShown: false,
});

export default SharePlayPage;
